/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { ReactNode } from 'react';

import { withWidth, withStyles, Typography } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

import logoPlurallUnsmile from 'assets/images/logo-plurall-unsmile.svg';

import { useStyles } from './styles';

export interface GlobalErrorBoundaryState {
  hasError: any;
}

type ClassesType = {
  [Key in keyof ReturnType<typeof useStyles>]: string;
};

interface Props {
  children: ReactNode;
  classes: ClassesType;
  width: Breakpoint;
}

function getTestId(id: string): any {
  if (process.env.REACT_APP_NODE_ENV !== 'production') {
    return {
      'data-testid': id,
    };
  }

  return {};
}

class GlobalErrorBoundary extends React.Component<
  Props,
  GlobalErrorBoundaryState
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error: any): any {
    return { hasError: typeof error === 'string' ? { message: error } : error };
  }

  render() {
    const { hasError } = this.state;
    const { children, classes } = this.props;

    const errorCode = hasError?.code ? hasError.code : hasError?.message;

    if (hasError) {
      return (
        <div className={classes.root} {...getTestId('error-container')}>
          <Typography
            variant="h4"
            className={classes.title}
            {...getTestId('error-title')}
          >
            Ocorreu um erro ao acessar a aplicação.
          </Typography>

          <Typography
            className={classes.subtitle}
            {...getTestId('error-message')}
          >
            {!!hasError && hasError?.message}
          </Typography>

          <Typography
            variant="caption"
            className={classes.errorCode}
            {...getTestId('error-code')}
          >
            Código: {errorCode}
          </Typography>
          <img
            {...getTestId('error-image')}
            className={classes.logo}
            src={logoPlurallUnsmile}
            alt="Logo Plurall"
          />
        </div>
      );
    }

    return children;
  }
}

export const GlobalErrorBoundaryWithoutStyles = withWidth()(
  withStyles(useStyles as any)(GlobalErrorBoundary as any),
) as any;
